export enum ExpirationPolicies {
	RESTRICTED = 'restricted',
	UNRESTRICTED = 'unrestricted'
}

export enum SeatOveragePolicies {
	RESTRICTED = 'restricted',
	UNRESTRICTED = 'unrestricted'
}
